import { render, staticRenderFns } from "./TraditionalGame.vue?vue&type=template&id=237857a1&scoped=true&"
import script from "./TraditionalGame.vue?vue&type=script&lang=js&"
export * from "./TraditionalGame.vue?vue&type=script&lang=js&"
import style0 from "./TraditionalGame.vue?vue&type=style&index=0&id=237857a1&lang=scss&scoped=true&"
import style1 from "./TraditionalGame.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237857a1",
  null
  
)

export default component.exports